module.exports = __webpack_public_path__ + "img/logo.80b6c169.png";